import CustomSelect from "./components/CustomSelect";
import LazyLoadImages from "vanilla-lazyload";
import AccordionsHandler from "./components/AccordionsHandler";
import TabHandler from "./home-page/TabHandler";
import CustomScrollbars from "./components/CustomScrollbars";
import SwitchActiveLogo from "./components/SwitchActiveLogo";
import NumberToolTip from "./components/NumbersToolTip";
import SwitchServices from "./home-page/SwitchServices";
import ShowMoreText from "./components/ShowMoreText";
import Map from "./components/Map";
import BoxesSlider from "./sliders/BoxesSlider";
import Header from "./header/Header";
import WorkersSlider from "./sliders/WorkersSlider";
import ClientsLogo from "./sliders/ClientsLogo";
import TagsSlider from "./sliders/TagsSlider";
import CanvasAnimation from "./components/CanvasAnimation";
import SelectTabHandler from "./home-page/SelectTabHandler";
import SelectBar from "./components/Selectbar";
import CountTo from "./components/CountTo";
import Modal from "./components/Modal";
import YouTubePlayer from "youtube-player";
import LightBox from "./components/LightBox";
import ContactFormConversion from "./components/ContactFormConversion";
import ChangeLanguageSwitcherContent from "./components/ChangeLanguageSwitcherContent";
import MenuHandler from "./header/MenuHandler";
import TechnologiesLogoSlider from "./sliders/TechnologiesLogoSlider";
import BottomBarHandler from "./components/BottomBarHandler";
import FormSendHandler from "./components/FormSendHandler";
import { AccordionSection } from "./sections/AccordionSection";

import AOS from "aos";
import "aos/dist/aos.css";

document.addEventListener("DOMContentLoaded", async () => {
    const lazy = new LazyLoadImages();
    new NumberToolTip();
    new ShowMoreText();
    new Header().init();
    new LightBox();
    new MenuHandler().init();

    await handleContactModal();
    await handleFormModal();
    await handleCountTo();
    await handleCustomSelect();
    await handleSelectBar();
    await handleTabs();
    await handleAccordions();
    await handleScrollbars();
    await handleActiveLogo();
    await handleSwitchServices();
    await handleMap();
    await handleBoxesSlider();
    await handleWorkersSlider();
    await handleClientsLogoSlider();
    await handlePodcatsTagsSlider();
    await handleBlogTagsSlider();
    await handleCanvasAnimation();
    await handleCustomTabsSelect();
    await handleScrollToSection();
    await handleYoutubeVideo();
    await handleContactFormConversion();
    await hendleChangeLanguageSwitcherContent();
    await handleTechnologiesSlider();
    await handleBottomBar();
    await formHandler();
    await handleAccordionSection();

    document.addEventListener("fetched_data", () => lazy.update());
    AOS.init();
});

const handleAccordionSection = async (): Promise<void> => {
    const section = document.querySelector<HTMLElement>(".accordion-section");

    if (section) new AccordionSection(section).init();
};

const handleContactModal = async (): Promise<void> => {
    const modalTogglers = document.querySelectorAll<HTMLElement>(".contact-modal-toggler");

    await handleModal(modalTogglers);
};

const handleFormModal = async (): Promise<void> => {
    const modalTogglers = document.querySelectorAll<HTMLElement>("[js-modal-toggler]");

    await handleModal(modalTogglers);
};

const handleModal = async (modalTogglers) => {
    const modalWrapper = document.querySelector<HTMLElement>(".contact-modal");
    const modalElement = document.querySelector<HTMLElement>(".modal__content");

    if (modalTogglers.length === 0 || !modalWrapper || !modalElement) return;

    new CustomScrollbars(modalElement);
    const modal = new Modal(modalWrapper, modalWrapper.querySelector(".modal__close"), "modal--visible");

    await modal.init();

    modalTogglers.forEach((item) => {
        item.addEventListener("click", () => {
            modal.openModal();
        });
    });
};

const handleCountTo = async (): Promise<void> => {
    const elements = [...document.querySelectorAll<HTMLElement>(".count-to")];

    elements.forEach((item) => {
        new CountTo(item).init();
    });
};

const handleSelectBar = async (): Promise<void> => {
    const selectBars = [...document.querySelectorAll<HTMLElement>(".select-bar")];

    if (selectBars.length === 0) return;

    selectBars.forEach((item) => {
        new SelectBar(item).init();
    });
};

const handleCustomSelect = async (): Promise<void> => {
    const selectWrapper = <HTMLElement>document.querySelector(".custom-select-wrapper");

    if (!selectWrapper) return;
    new CustomSelect(selectWrapper);
};

const handleAccordions = async (): Promise<void> => {
    const wrapper = document.querySelector(".accordions-handler") as HTMLElement;

    if (!wrapper) return;

    new AccordionsHandler(wrapper);
};

const handleTabs = async (): Promise<void> => {
    const tabSection = <HTMLElement>document.querySelector(".tabs");

    if (!tabSection) return;

    new TabHandler(tabSection);
    new SelectTabHandler(tabSection);
};

const handleScrollbars = async (): Promise<void> => {
    const elements = [...document.querySelectorAll<HTMLElement>(".custom-scrollbar")];

    if (elements.length === 0) return;

    elements.forEach((el) => {
        new CustomScrollbars(el);
    });
};

const handleActiveLogo = async (): Promise<void> => {
    const opinionsWrapper = <HTMLElement>document.querySelector(".clients-opinion-wrapper__second-column");

    if (!opinionsWrapper) return;

    new SwitchActiveLogo(opinionsWrapper);
};

const handleMap = async (): Promise<void> => {
    const map = document.getElementById("map");

    if (map !== null && map !== undefined) {
        new Map(map);
    }
};

const handleBoxesSlider = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".box-slider");

    if (!section) return;

    new BoxesSlider(section);
};

const handleWorkersSlider = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".two-cols-workers");

    if (!section) return;

    new WorkersSlider(section);
};

const handleClientsLogoSlider = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".clients-logo");

    if (!section) return;

    new ClientsLogo(section);
};

const handlePodcatsTagsSlider = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".podcasts");

    if (!section) return;

    new TagsSlider(section);
};

const handleBlogTagsSlider = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".blog-page");

    if (!section) return;

    new TagsSlider(section);
};

const handleCanvasAnimation = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector("hero");

    if (!section) return;

    new CanvasAnimation(section);
};

const handleCustomTabsSelect = async (): Promise<void> => {
    const wrapper = <HTMLElement>document.querySelector(".tabs-mobile-selects");

    if (!wrapper) return;

    new CustomSelect(wrapper);
};

const handleSwitchServices = async (): Promise<void> => {
    const section = <HTMLElement>document.querySelector(".what-we-do");

    if (!section) return;

    new SwitchServices(section);
};

const handleScrollToSection = async (): Promise<void> => {
    const links = [...document.querySelectorAll<HTMLAnchorElement>("a[href^='#']")];

    if (links.length === 0) return;

    links.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();

            const href = link.getAttribute("href") as string;
            if (!href) return;

            const section = document.querySelector(href) as HTMLElement;
            if (!section) return;

            const header = document.querySelector(".header") as HTMLElement;
            if (!header) return;

            const headerHeight = header.offsetHeight as number;

            window.scrollTo({
                top: section.offsetTop - headerHeight,
                behavior: "smooth",
            });
        });
    });
};

const handleYoutubeVideo = async (): Promise<void> => {
    const video_containers = document.querySelectorAll<HTMLElement>(".youtube-player");

    if (!video_containers) return;

    video_containers.forEach((item: HTMLElement) => {
        const videoId = item.dataset.video_id as string | null;

        if (item != null && videoId != null) {
            const youtube_player = YouTubePlayer(item, {
                height: "550",
                width: "1100",
                videoId: videoId,
            }) as YouTubePlayer;

            //https://developers.google.com/youtube/iframe_api_reference?hl=pl#Loading_a_Video_Player
        }
    });
};

const handleContactFormConversion = async (): Promise<void> => {
    const form = document.querySelector<HTMLElement>(".wpcf7-form");

    if (!form) return;

    const cf7conversion = new ContactFormConversion();
    cf7conversion.init();
};

const hendleChangeLanguageSwitcherContent = async () => {
    const wrapper = document.querySelector("header");

    if (!wrapper) return;

    new ChangeLanguageSwitcherContent(wrapper).init();
};

const handleTechnologiesSlider = async () => {
    const section = document.querySelector(".images-slider") as HTMLElement;

    if (!section) return;

    new TechnologiesLogoSlider(section);
};

const handleBottomBar = async () => {
    const section = document.querySelector(".estimation-page") as HTMLElement;

    if (!section) return;

    new BottomBarHandler(section).init();
};

const formHandler = async () => {
    const forms = document.querySelectorAll<HTMLFormElement>(".contact-box form");

    if (forms.length < 1 || !forms) return;

    forms.forEach((form) => new FormSendHandler(form).init());
};
